/**
 * GraphQL Query
 * メールテンプレート一覧画面
 */

/**
 * メールテンプレート一覧
 */
export const GRAPH_QL_QUERY_MAIL_TEMPLATE_LIST =
`
query {
  mailTemplates( ?, types: [99] ) {
    edges {
      node {
        id
        uuid
        site {
          code
          name
        }
        type
        templateName
        from
        fromMine
        to
        cc
        bcc
        replyTo
        subject
        templateText
        templateHtml
        updatedAt
      }
    }
    totalCount
  }
}
`
